<template>
  <div>
    <a-form-model ref="form" :rules="rules" :model="form" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="用例名称" prop="name">
            <a-input v-model="form.name" placeholder="用例名称" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="优先级" prop="priority">
            <a-select v-model="form.priority" allow-clear>
              <a-select-option v-for="(item, key) in casePrioritys" :key="key" :value="item.value">
                <a-tag :color="item.color"> {{ item.label }} </a-tag>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col v-if="false" :span="12">
          <a-form-model-item label="是否优质" prop="priority">
            <a-select v-model="form.priority" allow-clear>
              <a-select-option v-for="(item, key) in casePrioritys" :key="key" :value="item.value">
                <a-tag :color="item.color"> {{ item.label }} </a-tag>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="所属模块" prop="module_id">
            <a-tree-select v-if="moduleData" v-model="form.module_id" show-search :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择所属目录" :tree-data="moduleData" tree-default-expand-all @change="onChange('module_id')" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="前置条件">
            <a-textarea v-model="form.precondition" placeholder="前置条件" :auto-size="{ minRows: 3 }" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="用例步骤" prop="steps">
            <a-table class="steps_table" :pagination="false" :columns="columns" :data-source="form.steps" :custom-row="customRow" :row-key="(_, index) => index">
              <span slot="step" slot-scope="text, record">
                <a-textarea v-model="record.step" :auto-size="autoSize" placeholder="操作步骤" />
              </span>
              <span slot="result" slot-scope="text, record">
                <a-textarea v-model="record.result" :auto-size="autoSize" placeholder="预期结果" />
              </span>
              <span slot="images" slot-scope="text, record">
                <CaseStepImages :data-list.sync="record.images" :is-edit="true" />
              </span>
              <span slot="action" slot-scope="text, record, index">
                <a-tooltip placement="top" title="删除步骤">
                  <span class="icon-wrap" @click.stop="deleteStep(index)">
                    <a-icon type="delete" />
                  </span>
                </a-tooltip>
              </span>
            </a-table>
            <a v-tc="{ name: '添加步骤' }" class="add-step" type="link" @click="onAddStep"><a-icon type="plus" /> 添加步骤</a>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="用例标签" prop="tags">
            <a-select v-model="form.tags" mode="multiple" :max-tag-count="5" placeholder="请选择用例标签">
              <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="备注" prop="description">
            <vditor-editor v-model="form.description" :height="200" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { casePrioritys } from '@/utils/dictionary';
import VditorEditor from '@/components/VditorEditor';
import { moduleList, caseCreate, caseUpdate } from '@/api/project/case';
import CaseStepImages from '@/pages/project/case/components/CaseStepImages';

const columns = [
  {
    title: '操作步骤',
    dataIndex: 'step',
    key: 'step',
    width: 300,
    scopedSlots: { customRender: 'step' }
  },
  {
    title: '预期结果',
    dataIndex: 'result',
    key: 'result',
    width: 300,
    scopedSlots: { customRender: 'result' }
  },
  {
    title: '图片',
    dataIndex: 'images',
    key: 'images',
    width: 170,
    scopedSlots: { customRender: 'images' }
  },
  {
    key: 'action',
    width: 30,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: { VditorEditor, CaseStepImages },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns,
      casePrioritys,
      moduleData: [],
      tagData: [],
      form: {
        steps: []
      },
      autoSize: {
        minRows: 1
      },
      projectId: parseInt(this.$route.params.project_id) || null,
      rules: {
        name: [{ required: true, message: '用例名称不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        module_id: [{ required: true, message: '所属目录不能为空', trigger: 'blur' }],
        precondition: [{ required: true, message: '前置条件不能为空', trigger: 'blur' }]
      },
      dragSourceIdx: null,
      dragDestIdx: null,
      dragSourceRecord: null
    };
  },
  watch: {
    dataSource: {
      immediate: true,
      handler(value) {
        this.getTagList();
        this.getModuleList();
        // 如果有值，说明是编辑用例，否则是新增用例
        if (value && Object.keys(value).length > 0) {
          // 处理用例编辑表单数据
          this.form = {
            id: value.id,
            name: value.name,
            priority: value.priority,
            module_id: value.module_id,
            precondition: value.precondition,
            description: value.description ? value.description : '',
            steps: value.steps.length > 0 ? value.steps : [{ step: null, result: null, images: null }],
            tags: value.tags.map(item => {
              return item.id;
            })
          };
        } else {
          const moduleId = parseInt(this.$route.query.module_id) || null;
          this.form = {
            module_id: moduleId > 0 ? moduleId : null,
            steps: [{ step: null, result: null, images: null }]
          };
        }
      }
    }
  },

  methods: {
    customRow(record, index) {
      return {
        // FIXME: draggable： true 不生效还不晓得是什么原因，先使用鼠标移入事件设置目标行的draggable属性
        props: {
          draggable: 'true'
        },
        on: {
          // 鼠标移入
          mouseenter: event => {
            var ev = event || window.event;
            ev.target.draggable = true;
          },
          dragstart: event => {
            var ev = event || window.event;
            ev.stopPropagation();
            this.dragSourceIdx = index;
            this.dragSourceRecord = record;
          },
          dragover: event => {
            var ev = event || window.event;
            ev.preventDefault();
          },
          drop: event => {
            var ev = event || window.event;
            ev.stopPropagation();
            this.dragDestIdx = index;
            if (this.dragDestIdx !== this.form.steps.length - 1) {
              this.form.steps.splice(this.dragDestIdx, 0, this.dragSourceRecord);
            } else {
              // 由于组件不能拖到缝隙，所以实现支持拖到最后一行，但不支持直接拖到倒数第二行
              // 从概率上来说，拖到最后一行比倒数第二行高 -- wangleilei
              this.form.steps.push(this.dragSourceRecord);
            }
            if (this.dragSourceIdx > this.dragDestIdx) {
              this.form.steps.splice(this.dragSourceIdx + 1, 1);
            } else {
              this.form.steps.splice(this.dragSourceIdx, 1);
            }
          }
        }
      };
    },

    initForm() {
      this.form = {
        module_id: this.form.module_id,
        steps: [{ step: null, result: null, images: null }]
      };
    },

    /**
     * 获取标签列表
     */
    getTagList() {
      tagList({ group_code: 'case' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    /**
     * 过滤模块
     * @param {*} searchValue
     * @param {*} treeNode
     */
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },

    /**
     * 获取模块列表
     */
    getModuleList() {
      moduleList({ project_id: this.projectId, return_type: 'tree' }).then(res => {
        this.moduleData = res.data.items;
      });
    },

    /**
     * 删除步骤
     * @param {number} index
     */
    deleteStep(index) {
      this.form.steps.splice(index, 1);
    },

    /**
     * 添加步骤
     */
    onAddStep() {
      this.form.steps.push({ step: null, result: null, images: [] });
    },

    /**
     * 数据变更的回调
     */
    onChange(target) {
      this.$refs.form.validateField([target]);
    },

    /**
     * 提交
     */
    async onSubmit() {
      const valid = await new Promise((resolve, _) => {
        this.$refs.form.validate(resolve);
      });

      if (!valid) {
        return false;
      }

      try {
        if (this.form.id) {
          const { code, message } = await caseUpdate({ ...this.form, project_id: this.projectId });
          if (code === 2000) {
            this.$message.success('用例修改成功');
            return true;
          } else {
            this.$message.warning(message);
            return false;
          }
        } else {
          const { code, message } = await caseCreate({ ...this.form, project_id: this.projectId });
          if (code === 2000) {
            this.$message.success('用例创建成功');
            this.initForm();
            return true;
          } else {
            this.$message.warning(message);
            return false;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/.ant-form-item {
  margin-bottom: 8px;
}

/deep/ .steps_table .ant-input {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  margin: 2px 0;
  // border-bottom: 1px solid #d9d9d9;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:focus {
  border: none;
  border-bottom: 1px solid #1890ff;
  box-shadow: none;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:hover {
  border-bottom: 1px solid #1890ff;
}

/deep/.ant-table-tbody > tr > td {
  padding: 0;
}

.steps_table {
  margin-bottom: 4px;
}

.icon-wrap {
  cursor: pointer;
}
</style>
